import React from 'react'
import Image from 'gatsby-image'
import useHeroImages from '../../hooks/useHeroImage'
import { injectIntl } from 'react-intl'

export const PureHeroImage = ({ data, alt }) => {
  return (
    <Image
      alt={alt}
      data-gtm-category="landing_hero"
      data-gtm-label={alt}
      data-gtm-main-action="ab_test"
      data-gtm-category-ga4="landing_hero"
      data-gtm-label-ga4={alt}
      data-gtm-main-action-ga4="ab_test"
      draggable={false}
      fluid={data && data.childImageSharp.fluid}
    />
  )
}

const HeroImage = ({ lang, intl }) => {
  const data = useHeroImages()

  return <PureHeroImage alt={intl.formatMessage({ id: 'homeHeroImageAlt' })} data={data[lang]} />
}

export default injectIntl(HeroImage)
